import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import TranscriptRecordsByStudentRoute from "./routes/TranscriptRecordsByStudent";
import StudentTranscriptDetailsRoute from "./routes/StudentPersonalDetails";

export default store => ({
  path: ":yearGroupId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "transcripts-records" */ "./components"),
      import(
        /* webpackChunkName: "transcripts-records" */ "./module/transcriptRecordsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "transcriptV2Records",
        reducer,
      });
      return component;
    })
  ),

  childRoutes: [
    TranscriptRecordsByStudentRoute(store),
    StudentTranscriptDetailsRoute(store),
  ],
});
